import { invokeService } from '@alife/tarot';

const Module = {
  name: 'header',
  initState: {
    list: []
  },
  reducers: {
    resetList(state) {
      return {
        ...state,
        list: []
      }
    }
  },
  effects: {
    * getList(actions, { put, call }) {
      const {payload} = actions;
      payload.exp = window.pageConfig.exp;

      try {
        const result = yield call(invokeService, 'getSuggestKeywordList', payload);

        const list = result.body.result || [];
        const list2 = [];
        list.forEach((item) => {
          list2.push({
            label: item[0].replace(/(%|_)/g, ""),
            value: item[0],
            count: item[1]
          })
        })
        // 数据更新依然需要交给 reducer
        yield put("header/setValues", {
          list: list2
        });

      } catch (e) {
        yield put("header/setValues", {
          list: [],
        });
        throw e;
      }
    }
  }
};


export default Module;
